export enum BadgesEnum {
  OUT_TRANSACTIONS = "outTransactions",
  WEBMASTERS = "webmasters",
  OFFER_PARAMETER_REQUESTS = "offerParameterRequests",
  CHANGE_MANAGER_REQUESTS = "changeManagerRequests"
}